import { RESET_PASSWORD} from '../types/types'

export const setResetPassword =(value)=>{
    
      return{
          
          type:RESET_PASSWORD,
          payload : {data:value}
      }
}